import { render, staticRenderFns } from "./bar-vertical.component.vue?vue&type=template&id=8807f280&scoped=true&"
import script from "./bar-vertical.component.vue?vue&type=script&lang=js&"
export * from "./bar-vertical.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8807f280",
  null
  
)

export default component.exports